exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".community_chanel[data-v-69e311d8],.togs_of[data-v-69e311d8]{margin:0;text-align:center;text-transform:capitalize}.humtog_s[data-v-69e311d8]{margin-bottom:20px;background-color:#f5f8fa}.comtt_c[data-v-69e311d8]{border-left:none!important}.community_togs[data-v-69e311d8]{padding-left:15px!important;list-style-type:none}.h_b[data-v-69e311d8]{background-color:#5587d7;color:#fff;border-radius:20px;padding:7px 17px 10px}.f_f[data-v-69e311d8]{text-align:justify}.f_f_m[data-v-69e311d8]{text-align:center;margin-left:62px!important}.f_f a[data-v-69e311d8]{argin:62px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69e311d8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/sidebars/UsersSidebar.vue
// module id = SS+v
// module chunks = 0